/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PageTile from '../items/PageTile';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/section.module.scss';

const propTypes = {
    section: PropTypes.shape({
        id: PropTypes.string,
        slug: PropTypes.string,
    }),
    body: PropTypes.string,
    image: AppPropTypes.image,
    isContainer: PropTypes.bool,
    currentIndex: PropTypes.number,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    section: null,
    body: null,
    image: null,
    isContainer: false,
    currentIndex: 0,
    className: null,
    containerClassName: null,
};

const Section = ({
    section,
    body,
    image,
    isContainer,
    currentIndex,
    className,
    containerClassName,
}) => {
    const {
        title = null,
        shortName = null,
        url = null,
        theme = null,
        handle = null,
    } = section || {};

    const { highlights = null } = theme || {};

    const reverse = useMemo(() => {
        const finalIndex = parseInt(currentIndex, 10);
        return finalIndex === 0 || finalIndex % 2 === 0;
    }, [currentIndex]);

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <PageTile
                    title={title}
                    cta={
                        <FormattedMessage
                            defaultMessage="View {title}"
                            description="Button label"
                            values={{ title: shortName || title }}
                        />
                    }
                    body={body}
                    url={url}
                    color={highlights}
                    image={image}
                    withoutLinks={handle === 'technologies'}
                    reverse={reverse}
                />
            </div>
        </div>
    );
};

Section.propTypes = propTypes;
Section.defaultProps = defaultProps;

export default Section;
